export default __webpack_public_path__ + "static/media/logo.15fc40fe.png";